import {header} from "./modules/header";
import {triggerModal} from "./modules/modal";
import { initReferralTracking } from './modules/referral';
import {initLabel} from "./modules/floatlabel";
import {handleFormSubmit} from './modules/form';
import {initSmoothScroll} from "./modules/smoothscroll";
import { initAnim } from "./modules/animations";
import { qtyControl } from './modules/qty-control';
import { CustomSelect } from './modules/select';
import FormDatePicker from "./modules/FormDatePicker";
import { counter } from "./modules/counter";
import { stickyButton } from "./modules/stickyButton";

document.addEventListener("DOMContentLoaded", function () {
  initReferralTracking()
  header().init()
  triggerModal()
  initLabel()
  handleFormSubmit().init();
  initSmoothScroll().init()
  initAnim().init()
  qtyControl()
  counter()
  setTimeout(function () {
     CustomSelect();
  }, 2500)
  new FormDatePicker();
  stickyButton()
})
